<template>
  <div class="renderPage art-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="art-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-package-variant</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase art-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Catálogo de Artículos
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="mr-2 art-btn font-weight-bold" @click="incluir()">
        <v-icon left small>mdi-plus</v-icon> Nuevo Artículo
      </v-btn>
      <v-btn depressed :color="$vuetify.theme.dark ? 'blue-grey darken-2' : 'blue-grey darken-3'" dark class="art-btn font-weight-bold" to="/familias">
        <v-icon left small>mdi-tag-multiple-outline</v-icon> Familias
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="art-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="52" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar por código, nombre o barras..."
          single-line hide-details outlined dense
          class="art-search"
        ></v-text-field>
        <v-spacer />
        <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="art-table"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="art-code-badge">{{ item.codigo }}</span>
        </template>

        <template v-slot:[`item.nombre`]="{ item }">
          <div class="d-flex flex-column py-1">
            <span class="font-weight-bold text-body-2">{{ item.nombre }}</span>
            <span class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">{{ item.cabys }}</span>
          </div>
        </template>

        <template v-slot:[`item.monto`]="{ item }">
          <span class="font-weight-black" :class="$vuetify.theme.dark ? 'teal--text text--lighten-2' : 'success--text'">₡{{ item.monto.toLocaleString() }}</span>
        </template>

        <template v-slot:[`item.existencia`]="{ item }">
          <v-chip small label class="font-weight-bold"
            :color="item.existencia > 0 ? 'success' : 'error'" dark>
            {{ item.existencia }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-end" style="gap:4px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
                  <v-icon size="18">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="info" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="clonarItem(item)">
                  <v-icon size="18">mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>Clonar</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-package-variant-closed-remove</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No hay artículos registrados.</p>
            <v-btn color="primary" depressed small @click="getData()">Actualizar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DRAWER FORMULARIO -->
    <v-navigation-drawer v-model="drawerForm" fixed right temporary :persistent="dialogCabys" width="900" class="art-drawer">
      <div class="d-flex flex-column fill-height">

        <!-- HEADER DRAWER -->
        <div class="art-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'art-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">{{ editedIndex > -1 ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex > -1 ? 'Editar Artículo' : 'Nuevo Artículo' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">{{ editedItem.codigo || 'SIN CÓDIGO' }} · Catálogo</div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- TABS -->
        <v-form ref="form" v-model="valid" class="flex-grow-1 d-flex flex-column overflow-hidden">
          <v-tabs v-model="tab" grow height="48" color="primary" class="art-tabs flex-grow-0"
            :background-color="$vuetify.theme.dark ? '#1e293b' : '#f8fafc'"
            :dark="$vuetify.theme.dark">
            <v-tab class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px">General</v-tab>
            <v-tab class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px">Precios</v-tab>
            <v-tab class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px">Inventario</v-tab>
            <v-tab class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px">Logística</v-tab>
            <v-tab class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px">Proveedores</v-tab>
          </v-tabs>
          <v-divider />

          <v-tabs-items v-model="tab" class="flex-grow-1 overflow-y-auto art-tabs-body">

            <!-- TAB 1: GENERAL -->
            <v-tab-item class="pa-6">
              <div class="art-section-label mb-3">
                <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-information-outline</v-icon>
                <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Información General</span>
              </div>
              <v-card flat class="art-section-card pa-4 mb-4">
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.codigo" label="Código Interno" outlined dense readonly class="bg-input-disabled" prepend-inner-icon="mdi-identifier"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-select v-model="editedItem.familia" :items="familias" item-text="nombre" item-value="codigo" label="Familia / Categoría" outlined dense prepend-inner-icon="mdi-tag-outline" clearable></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="editedItem.nombre" label="Descripción del Producto" outlined dense prepend-inner-icon="mdi-format-title" :rules="nameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="9">
                    <v-text-field v-model="editedItem.cabys" label="Código Cabys (Hacienda)" outlined dense prepend-inner-icon="mdi-barcode-scan" :rules="nameRules" required></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <v-btn color="primary" depressed block height="40" class="font-weight-bold art-btn" @click="mostrarCabys">
                      <v-icon left size="16">mdi-magnify</v-icon> CABYS
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select v-model="editedItem.unidad" :items="unidades" item-text="un_nombre" item-value="un_codigo" label="Unidad de Medida" outlined dense prepend-inner-icon="mdi-scale"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select v-model="editedItem.estado" :items="estados" label="Estado" outlined dense prepend-inner-icon="mdi-check-circle-outline"></v-select>
                  </v-col>
                  <v-col cols="12" v-if="barrasError">
                    <v-alert type="error" dense outlined class="mb-0" dismissible @input="barrasError = ''">
                      <div class="font-weight-bold text-body-2">⚠️ Código de barras duplicado</div>
                      <div class="caption">{{ barrasError }}</div>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.barras" label="Barras 1 (Principal)" outlined dense prepend-inner-icon="mdi-barcode" :error-messages="barrasErrorField === 'Código de barras 1' ? barrasError : ''" @input="barrasError = ''"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.barras2" label="Barras 2 (Alternativo)" outlined dense prepend-inner-icon="mdi-barcode" :error-messages="barrasErrorField === 'Código de barras 2' ? barrasError : ''" @input="barrasError = ''"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.barras3" label="Barras 3 (Alternativo)" outlined dense prepend-inner-icon="mdi-barcode" :error-messages="barrasErrorField === 'Código de barras 3' ? barrasError : ''" @input="barrasError = ''"></v-text-field>
                  </v-col>
                </v-row>
                <v-divider class="my-3" />
                <div class="d-flex align-center justify-space-between px-1">
                  <div>
                    <div class="font-weight-bold text-body-2">Artículo Genérico</div>
                    <div class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">Permite modificar el precio libremente al facturar</div>
                  </div>
                  <v-switch v-model="editedItem.esGenerico" inset dense color="primary" hide-details></v-switch>
                </div>
              </v-card>

              <v-expand-transition>
                <v-card v-if="esFarmacia" flat class="art-section-card pa-4 mb-4">
                  <div class="art-section-label mb-3">
                    <v-icon small class="mr-1" color="primary">mdi-pill</v-icon>
                    <span class="font-weight-black text-caption text-uppercase primary--text" style="letter-spacing:1px">Información Farmacéutica</span>
                  </div>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field v-model="editedItem.registroMedicamento" label="Nº Registro" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select v-model="editedItem.formaFarmaceutica" :items="formas" item-text="descripcion" item-value="codigo" label="Forma Galénica" outlined dense></v-select>
                    </v-col>
                  </v-row>
                </v-card>
              </v-expand-transition>
            </v-tab-item>

            <!-- TAB 2: PRECIOS -->
            <v-tab-item class="pa-6">
              <div class="art-section-label mb-3">
                <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-cash-multiple</v-icon>
                <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Costos y Precios</span>
              </div>
              <v-card flat class="art-section-card pa-4">
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.costo" @input="updateFromCosto" label="Costo Compra" outlined dense type="number" prefix="₡" prepend-inner-icon="mdi-cash-minus"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field :value="utilidad" @input="updateFromUtilidad" label="Utilidad Actual" outlined dense prepend-inner-icon="mdi-trending-up" :color="utilidad >= parseFloat(editedItem.utilidadMinima || 0) ? 'success' : 'error'" class="font-weight-bold" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.utilidadMinima" label="Utilidad Mín." outlined dense type="number" suffix="%" prepend-inner-icon="mdi-shield-alert-outline"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field :value="precios.sinIva" @input="updateFromNeto" label="Precio Sin IVA" outlined dense type="number" prefix="₡" prepend-inner-icon="mdi-cash-outline"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.tarifa" label="IVA %" outlined dense readonly prepend-inner-icon="mdi-percent" class="bg-input-disabled"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="precios.iva" label="Monto IVA" outlined dense readonly prepend-inner-icon="mdi-calculator" class="bg-input-disabled"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="mt-2">
                    <v-text-field
                      v-model="editedItem.monto"
                      @input="updateFromTotal"
                      label="Precio Venta Final (con IVA)"
                      outlined
                      prefix="₡"
                      prepend-inner-icon="mdi-cash-check"
                      :color="utilidad >= parseFloat(editedItem.utilidadMinima || 0) ? 'success' : 'error'"
                      class="hero-input-minimal-alt"
                      :error="utilidad < parseFloat(editedItem.utilidadMinima || 0)"
                      persistent-hint
                      :hint="utilidad < parseFloat(editedItem.utilidadMinima || 0) ? '⚠️ El margen es menor al mínimo configurado' : ''"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <!-- TAB 3: INVENTARIO -->
            <v-tab-item class="pa-6">
              <div class="art-section-label mb-3">
                <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-package-variant-closed</v-icon>
                <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Control de Stock</span>
              </div>
              <v-card flat class="art-section-card pa-4">
                <v-row dense>
                  <v-col cols="12" sm="8">
                    <v-text-field
                      v-model="editedItem.existencia"
                      label="Existencia Actual"
                      outlined dense type="number"
                      prepend-inner-icon="mdi-warehouse"
                      :readonly="editedIndex > -1"
                      :class="editedIndex > -1 ? 'bg-input-disabled' : ''"
                      class="font-weight-black"
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <div class="d-flex align-center justify-space-between px-3 fill-height art-toggle-row">
                      <span class="caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">AFECTA INV.</span>
                      <v-switch v-model="editedItem.afectaInventario" inset color="primary" hide-details class="mt-0"></v-switch>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" class="mt-3">
                    <v-text-field v-model="editedItem.existenciaMin" label="Nivel Reorden (Mín)" outlined dense type="number" prepend-inner-icon="mdi-trending-down" color="error"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="mt-3">
                    <v-text-field v-model="editedItem.existenciaMax" label="Capacidad Máx" outlined dense type="number" prepend-inner-icon="mdi-trending-up" color="info"></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <!-- TAB 4: LOGÍSTICA -->
            <v-tab-item class="pa-6">
              <div class="art-section-label mb-3">
                <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-truck-cargo-container</v-icon>
                <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Gestión de Abastecimiento</span>
              </div>
              <v-card flat class="art-section-card pa-4 mb-4">
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <v-select v-model="editedItem.seCompraPor" :items="comprasUnidades" label="Unid. Compra" outlined dense prepend-inner-icon="mdi-shopping-outline"></v-select>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="editedItem.unidadesPorPaquete" label="Factor Conversión" outlined dense type="number" prepend-inner-icon="mdi-numeric-1-box-multiple" persistent-hint hint="Unid por empaque"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-autocomplete v-model="editedItem.proveedorCodigo" :items="proveedores" item-text="nombre" item-value="codigo" label="Proveedor Sugerido" outlined dense clearable prepend-inner-icon="mdi-handshake-outline"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card>
              <v-alert text color="blue-grey" icon="mdi-information-outline" class="caption" dense>
                Configurar la conversión permite que al recibir mercadería, el stock se actualice automáticamente basado en las unidades contenidas en cada empaque.
              </v-alert>
            </v-tab-item>

            <!-- TAB 5: PROVEEDORES -->
            <v-tab-item class="pa-6">
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="art-section-label">
                  <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-group</v-icon>
                  <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Proveedores Vinculados</span>
                </div>
                <v-btn color="primary" depressed small class="art-btn font-weight-bold" @click="dialogProv = true">
                  <v-icon left small>mdi-plus</v-icon> Vincular
                </v-btn>
              </div>
              <v-card flat class="art-section-card">
                <v-data-table
                  :headers="headersProv"
                  :items="proveedoresArticulo"
                  class="art-table elevation-0"
                  hide-default-footer
                  dense
                >
                  <template v-slot:item.ultimoCosto="{ item }">
                    <span class="font-weight-bold primary--text">₡{{ (item.ultimoCosto || 0).toLocaleString() }}</span>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn icon small color="error" @click="desvincularProveedor(item)">
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-form>

        <!-- DIALOG VINCULAR PROVEEDOR -->
        <v-dialog v-model="dialogProv" max-width="480">
          <v-card flat class="art-dialog-card">
            <div class="art-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'art-drawer-header--dark' : ''">
              <v-icon color="white" small class="mr-2">mdi-link-plus</v-icon>
              <span class="white--text font-weight-black text-uppercase" style="font-size:0.85rem;letter-spacing:1px">Vincular Proveedor</span>
              <v-spacer />
              <v-btn icon dark x-small @click="dialogProv = false"><v-icon small>mdi-close</v-icon></v-btn>
            </div>
            <div class="pa-5">
              <v-autocomplete v-model="provVinculo.proveedorCodigo" :items="proveedores" item-text="nombre" item-value="cedula" label="Proveedor" outlined dense prepend-inner-icon="mdi-account-search"></v-autocomplete>
              <v-text-field v-model="provVinculo.codigoInternoProveedor" label="Código Interno (SKU del proveedor)" outlined dense prepend-inner-icon="mdi-barcode"></v-text-field>
              <v-text-field v-model="provVinculo.ultimoCosto" label="Costo Inicial" outlined dense type="number" prefix="₡" prepend-inner-icon="mdi-cash-minus"></v-text-field>
              <div class="d-flex justify-end mt-2">
                <v-btn text class="mr-2 font-weight-bold" @click="dialogProv = false">Cancelar</v-btn>
                <v-btn color="primary" depressed class="art-btn font-weight-bold" @click="vincularProveedor()">Guardar</v-btn>
              </div>
            </div>
          </v-card>
        </v-dialog>

        <!-- FOOTER ACCIONES -->
        <div class="art-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'art-drawer-footer--dark' : ''">
          <v-btn v-if="editedIndex > -1" color="error" text class="font-weight-bold art-btn" @click="deleteItem()">
            <v-icon left small>mdi-trash-can-outline</v-icon> Eliminar
          </v-btn>
          <v-btn v-if="editedIndex > -1" color="info" text class="font-weight-bold art-btn ml-2" @click="clonarItem()">
            <v-icon left small>mdi-content-copy</v-icon> Clonar
          </v-btn>
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold art-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold art-btn" :loading="loading" @click="save()">
            {{ editedIndex > -1 ? 'GUARDAR' : 'CREAR ARTÍCULO' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <!-- DIALOGO CABYS -->
    <v-dialog v-model="dialogCabys" width="1000" transition="dialog-bottom-transition" persistent>
      <v-card class="overflow-hidden">
        <template v-if="showCabysContent">
          <Cabys :allwedOnly="true" :initial-query="editedItem.nombre" @clicked="selectedCabys" @closed="closedCabys" />
        </template>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";
import Cabys from "./Cabys.vue";

export default {
  components: {
    Snackbar,
    Cabys,
  },
  data() {
    return {
      drawerForm: false,
      loading: false,
      dialogCabys: false,
      showCabysContent: false,
      valid: false,
      visible: false,
      search: "",
      snackText: "",
      snackValue: false,
      url: "api/Articulos/",
      esFarmacia: false,
      headers: [
        { text: "Código", value: "codigo", sortable: true },
        { text: "Nombre / Cabys", value: "nombre", sortable: true },
        { text: "Cod. Barras", value: "barras", sortable: true },
        { text: "Precio", value: "monto", align: 'right', sortable: true },
        { text: "Stock", value: "existencia", align: 'center', sortable: true },
        { text: "Acciones", value: "actions", sortable: false, align: 'right' },
      ],
      items: [],
      tiposArticulos: [],
      unidades: [],
      formas: [],
      proveedores: [],
      proveedoresArticulo: [],
      headersProv: [
        { text: "Proveedor", value: "proveedorNombre" },
        { text: "Cód. Interno", value: "codigoInternoProveedor" },
        { text: "Últ. Costo", value: "ultimoCosto", align: 'right' },
        { text: "", value: "actions", sortable: false, align: 'right' },
      ],
      dialogProv: false,
      provVinculo: {
        proveedorCodigo: "",
        codigoInternoProveedor: "",
        ultimoCosto: 0
      },
      editedIndex: -1,
      editedItem: {
        codigo: "",
        nombre: "",
        tipoArt: "",
        unidad: "",
        tarifa: 0,
        monto: 0, // Este será el Precio Venta (Total)
        barras: "",
        barras2: "",
        barras3: "",
        existencia: 0,
        costo: 0,
        peso: "",
        codigoImp: "",
        codigoTarifa: "",
        cabys: "",
        cia: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
        esGenerico: false,
        proveedorCodigo: "",
        // Nuevos
        familia: "",
        estado: "Activo",
        afectaInventario: true,
        utilidadMinima: 0,
        existenciaMin: 0,
        existenciaMax: 0,
        seCompraPor: "Unidad",
        unidadesPorPaquete: 1,
      },
      defaultItem: {
        codigo: "",
        nombre: "",
        tipoArt: "",
        unidad: "",
        tarifa: 0,
        monto: 0,
        barras: "",
        barras2: "",
        barras3: "",
        existencia: 0,
        costo: 0,
        peso: 0,
        codigoImp: "",
        codigoTarifa: "",
        cabys: "",
        cia: "",
        registroMedicamento: "",
        formaFarmaceutica: "",
        esGenerico: false,
        proveedorCodigo: "",
        familia: "",
        estado: "Activo",
        afectaInventario: true,
        utilidadMinima: 0,
        existenciaMin: 0,
        existenciaMax: 0,
        seCompraPor: "Unidad",
        unidadesPorPaquete: 1,
      },
      nameRules: [(v) => !!v || "Este campo es requerido"],
      familias: [],
      estados: ["Activo", "Inactivo", "Descontinuado"],
      comprasUnidades: ["Unidad", "Caja", "Rollo", "Paquete", "Saco"],
      tab: null,
      precios: {
        sinIva: 0,
        iva: 0,
        total: 0
      },
      barrasError: "",
      barrasErrorField: "",
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    utilidad() {
      const costo = parseFloat(this.editedItem.costo);
      const montoNeto = this.precios.sinIva;
      if (!costo || costo === 0) return 0;
      return (((montoNeto - costo) / costo) * 100).toFixed(2);
    },
  },

  watch: {
    'editedItem.monto': {
      handler(val) {
        if (this.updatingPrices) return;
        this.updateFromTotal(val);
      },
      immediate: true
    },
    'editedItem.tarifa': {
      handler() {
        this.updateFromTotal(this.editedItem.monto);
      }
    }
  },

  created() {
    this.getData();
    this.getTiposArticulos();
    this.getUnidades();
    this.getFormas();
    this.getProveedores();
    this.getFamilias();
  },

  methods: {
    getData() {
      let me = this;
      axios.get("api/Articulos/getArticulosByCompany?cia=" + this.strCia)
        .then(res => { me.items = res.data; })
        .catch(err => console.error(err));
    },

    getFamilias() {
      axios.get("api/Articulos/getFamilias?cia=" + this.strCia).then(res => { this.familias = res.data; });
    },

    updateFromNeto(neto) {
      this.updatingPrices = true;
      const n = parseFloat(neto) || 0;
      const t = parseFloat(this.editedItem.tarifa || 0) / 100;
      
      this.precios.sinIva = n;
      this.precios.iva = parseFloat((n * t).toFixed(2));
      this.precios.total = parseFloat((this.precios.sinIva + this.precios.iva).toFixed(2));
      this.editedItem.monto = this.precios.total;
      
      this.$nextTick(() => { this.updatingPrices = false; });
    },

    updateFromUtilidad(nuevaUtilidad) {
      const costo = parseFloat(this.editedItem.costo) || 0;
      if (costo === 0) return;
      const u = parseFloat(nuevaUtilidad || 0) / 100;
      const neto = costo * (1 + u);
      this.updateFromNeto(neto.toFixed(2));
    },

    updateFromCosto(nuevoCosto) {
      const u = parseFloat(this.utilidad) / 100;
      const costo = parseFloat(nuevoCosto) || 0;
      const neto = costo * (1 + u);
      this.updateFromNeto(neto.toFixed(2));
    },

    updateFromTotal(total) {
      this.updatingPrices = true;
      const tot = parseFloat(total) || 0;
      const t = 1 + (parseFloat(this.editedItem.tarifa || 0) / 100);
      
      this.precios.total = tot;
      this.precios.sinIva = parseFloat((tot / t).toFixed(2));
      this.precios.iva = parseFloat((tot - this.precios.sinIva).toFixed(2));
      
      this.$nextTick(() => { this.updatingPrices = false; });
    },

    getTiposArticulos() {
      axios.get("api/Articulos/getTipoArticulos").then(res => { this.tiposArticulos = res.data; });
    },

    getUnidades() {
      axios.get("api/Articulos/getUnidades").then(res => {
        this.unidades = res.data;
        this.defaultItem.unidad = "Unid";
        if (this.editedIndex === -1) this.editedItem.unidad = "Unid";
      });
    },

    getFormas() {
      axios.get("api/General/getFormaFarmaceutica").then(res => { this.formas = res.data; });
    },

    getProveedores() {
      axios.get("api/Proveedores/getProveedoresByCompany?cia=" + this.strCia).then(res => { this.proveedores = res.data; });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.updateFromTotal(this.editedItem.monto);
      this.checkFarmacia();
      this.getProveedoresArticulo();
      this.drawerForm = true;
    },

    incluir() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.updateFromTotal(0);
      this.esFarmacia = false;
      this.getProveedoresArticulo();
      axios.get("api/Articulos/getCodigoArticulo?cia=" + this.strCia).then(res => {
        this.editedItem.codigo = res.data;
      });
      this.drawerForm = true;
    },

    clonarItem(item) {
      // Copiar todos los datos del artículo seleccionado
      const clonado = Object.assign({}, item);
      // Limpiar campos que deben ser únicos o empezar en 0
      clonado.codigo = "";
      clonado.barras = "";
      clonado.barras2 = "";
      clonado.barras3 = "";
      clonado.existencia = 0;
      // Cambiar a modo "nuevo artículo"
      this.editedIndex = -1;
      this.editedItem = clonado;
      this.proveedoresArticulo = [];
      this.tab = 0;
      this.updateFromTotal(this.editedItem.monto);
      this.checkFarmacia();
      // Obtener nuevo código secuencial
      axios.get("api/Articulos/getCodigoArticulo?cia=" + this.strCia).then(res => {
        this.editedItem.codigo = res.data;
      });
      this.drawerForm = true;
      this.snackText = "Artículo clonado — modifica lo que necesites y guarda";
      this.snackValue = true;
    },

    mostrarCabys() {
      this.showCabysContent = true;
      this.dialogCabys = true;
    },

    selectedCabys(value) {
      // Refuerzo Nivel Ultra Pro: Forzamos que el drawer siga abierto durante la transición
      this.drawerForm = true; 

      this.editedItem.nombre = value.descripcion;
      this.editedItem.cabys = value.codigo;
      this.editedItem.tarifa = value.impuesto;

      // Mapeo automático de código de tarifa para Hacienda
      if (value.impuesto == 13) this.editedItem.codigoTarifa = '08';
      else if (value.impuesto == 1) this.editedItem.codigoTarifa = '02';
      else if (value.impuesto == 2) this.editedItem.codigoTarifa = '03';
      else if (value.impuesto == 4) this.editedItem.codigoTarifa = '04';
      else if (value.impuesto == 8) this.editedItem.codigoTarifa = '07';
      else if (value.impuesto == 0) this.editedItem.codigoTarifa = '01';
      else this.editedItem.codigoTarifa = '08'; // Seguridad por defecto

      this.updateFromTotal(this.editedItem.monto);
      this.checkFarmacia();
      this.closedCabys();

      // Pequeño delay para asegurar que el cierre del diálogo no se lleve al drawer
      setTimeout(() => {
        this.drawerForm = true;
      }, 50);
    },

    closedCabys() {
      this.showCabysContent = false;
      this.dialogCabys = false;
    },

    checkFarmacia() {
      const prefix = (this.editedItem.cabys || "").substring(0, 4);
      this.esFarmacia = (prefix === "3562" || prefix === "3563");
    },

    // Gestión de N Proveedores
    async getProveedoresArticulo() {
       if (this.editedIndex === -1) {
          this.proveedoresArticulo = [];
          return;
       }
       try {
          const res = await axios.get(this.url + "getProveedoresArticulo", { 
            params: { cia: this.strCia, codigo: this.editedItem.codigo } 
          });
          this.proveedoresArticulo = res.data;
       } catch (err) { console.error(err); }
    },

    async vincularProveedor() {
       try {
          const payload = {
             ...this.provVinculo,
             Cia: this.strCia,
             CodigoArticulo: this.editedItem.codigo
          };
          await axios.post(this.url + "saveProveedorArticulo", payload);
          this.dialogProv = false;
          this.provVinculo = { ProveedorCodigo: "", CodigoInternoProveedor: "", UltimoCosto: 0 };
          this.getProveedoresArticulo();
       } catch (err) { console.error(err); }
    },

    async desvincularProveedor(item) {
       if (!confirm("¿Desvincular este proveedor del artículo?")) return;
       try {
          await axios.get(this.url + "deleteProveedorArticulo", {
             params: { 
               cia: this.strCia, 
               codigo: this.editedItem.codigo, 
               proveedorCodigo: item.ProveedorCodigo 
             }
          });
          this.getProveedoresArticulo();
       } catch (err) { console.error(err); }
    },

    cerrar() {
      this.drawerForm = false;
      this.barrasError = "";
      this.barrasErrorField = "";
      this.$nextTick(() => { 
        this.editedItem = Object.assign({}, this.defaultItem); 
        this.editedIndex = -1; 
      });
    },

    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.barrasError = "";
      this.barrasErrorField = "";
      let me = this;
      this.editedItem.cia = this.strCia;

      for (const unid of this.unidades) {
        if (unid.un_codigo === this.editedItem.unidad) {
          this.editedItem.tipoArt = unid.tipoArt;
        }
      }

      const url = this.editedIndex > -1 ? "api/Articulos/updateArticulo" : "api/Articulos/insertArticulo";
      axios.post(url, this.editedItem).then(() => {
        me.snackText = me.editedIndex > -1 ? "Artículo actualizado" : "Artículo creado";
        me.snackValue = true;
        me.getData();
        me.cerrar();
      }).catch(err => {
        if (err.response && err.response.status === 400 && err.response.data) {
          // Validación de duplicados del API
          me.barrasError = err.response.data.message;
          me.barrasErrorField = err.response.data.campoConflicto || "";
          me.snackText = err.response.data.message;
          me.snackValue = true;
          // Navegar al tab General para que el usuario vea el error
          me.tab = 0;
        } else {
          console.error(err);
          me.snackText = "Error al guardar el registro";
          me.snackValue = true;
        }
      }).finally(() => { this.loading = false; });
    },

    deleteItem() {
      if (!confirm("¿Está seguro de que desea eliminar este artículo?")) return;
      let me = this;
      axios.get("api/Articulos/deleteArticulo?cia="+this.strCia+"&codigo="+this.editedItem.codigo)
        .then(() => { me.getData(); me.cerrar(); })
        .catch(err => console.error(err));
    }
  },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.art-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.art-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.art-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .art-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.art-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.art-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== TABLE ===== */
.art-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.art-table { background: transparent !important; }
.art-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.art-table >>> tbody tr { cursor: pointer; }
.art-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .art-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== CODE BADGE ===== */
.art-code-badge {
  font-family: monospace;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 2px 6px;
  background: rgba(55, 71, 79, 0.08);
  border-radius: 3px;
  color: #37474f;
}
.theme--dark .art-code-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #b0bec5;
}

/* ===== SEARCH ===== */
.art-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* ===== DRAWER ===== */
.art-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .art-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}

/* ===== DRAWER HEADER ===== */
.art-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.art-drawer-header--dark {
  background-color: #263238 !important;
}

/* ===== DRAWER FOOTER ===== */
.art-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.art-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* ===== SECTION CARDS ===== */
.art-section-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}
.theme--dark .art-section-card {
  border-color: rgba(255, 255, 255, 0.07) !important;
  background-color: #1e293b !important;
}

/* ===== SECTION LABEL ===== */
.art-section-label {
  display: flex;
  align-items: center;
}

/* ===== TABS ===== */
.art-tabs >>> .v-tabs-bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.art-tabs >>> .v-tab {
  font-size: 0.72rem !important;
  letter-spacing: 1px;
  min-width: 80px;
}
.art-tabs-body {
  background-color: #f8fafc !important;
}
.theme--dark .art-tabs-body {
  background-color: #0f172a !important;
}

/* ===== TOGGLE ROW ===== */
.art-toggle-row {
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  height: 40px;
  padding: 0 12px;
}
.theme--dark .art-toggle-row {
  border-color: rgba(255, 255, 255, 0.1);
}

/* ===== DIALOG CARD ===== */
.art-dialog-card {
  border-radius: 4px !important;
  overflow: hidden;
}

/* ===== READONLY INPUTS ===== */
.bg-input-disabled >>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.theme--dark .bg-input-disabled >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== PRICE INPUT ===== */
.hero-input-minimal-alt >>> input {
  font-size: 1.5rem !important;
  font-weight: 900 !important;
  color: #10b981 !important;
  text-align: right;
}
.theme--dark .hero-input-minimal-alt >>> input {
  color: #4ade80 !important;
}
</style>